import './EnterSystemPassword.css';

import React, { useState } from 'react';
import { type PasswordTarget } from '@src/ConfigInfo';
import { messageBox } from '@src/style/style';
import { validatePassword } from './passwordApi';
import { PasswordInput, ConfirmPasswordButton, SkipSystemPasswordOnboardingButton } from './components';

interface SystemPasswordOnboardingContentProps {
  onPasswordEntered: () => void
  onSkipPassword: () => void
  passwordTargets: PasswordTarget[]
}

export const EnterSystemPassword = ({ onPasswordEntered, onSkipPassword, passwordTargets }: SystemPasswordOnboardingContentProps): JSX.Element => {
  const [password, setPassword] = useState('');
  const [isPasswordValidating, setIsPasswordValidating] = useState(false);
  const [hasPasswordValidationFailed, setHasPasswordValidationFailed] = useState(false);

  const completeSystemPasswordOnboarding = (): void => {
    setIsPasswordValidating(true);

    validatePassword(passwordTargets, password)
      .then(() => {
        setIsPasswordValidating(false);

        messageBox('Password validated', 'success');
        onPasswordEntered();
      })
      .catch((errors: string[]) => {
        setIsPasswordValidating(false);
        setHasPasswordValidationFailed(true);

        errors.forEach((error, index) => { messageBox(error, 'warning', { timeOut: 5000 + index * 1000 }); });
      });
  };

  const canValidatePassword = !isPasswordValidating && password !== '';

  return (
    <div id="enter_system_password_onboarding_content">
      <div id="enter_system_password_onboarding_content_message">Please enter your system password to secure the device you have added. If you have forgotten your system password, please contact us at +1-800-940-3617 or integrationsupport@vention.cc</div>
      <div id="enter_system_password_onboarding_content_controls">
        <PasswordInput label="Password" onChange={setPassword} />
        <ConfirmPasswordButton
          label="Validate System Password"
          onClick={completeSystemPasswordOnboarding}
          disabled={!canValidatePassword}
        />
        {hasPasswordValidationFailed ? <SkipSystemPasswordOnboardingButton onClick={onSkipPassword} /> : null}
      </div>
    </div>
  );
};
